import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  Cmtpax: '',
  CheckServices: {},
  PaxsGroup: {},
  Services: [],
  monetaryService: {},
  OverNightStation: {}
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
